import {
  getMonthWithDayFormatDate,
  getMonthYearFormat,
} from "@/utils/dateHelper";
import { useTranslation } from "react-i18next";
import FileBlue from "../../assets/icon/svgs/FileBlue.svg?react";
// import ChatDots from "../../assets/icon/svgs/ChatDots.svg?react";
// import HomeInfo from "../../assets/icon/svgs/HomeInfo.svg?react";
import Edit from "../../assets/icon/svgs/Edit.svg?react";
// import TotalBill from "../../assets/icon/svgs/TotalBillCurrentColor.svg?react";
// import SendNotification from "../../assets/icon/svgs/SendNotifi.svg?react";
import CallColor from "../../assets/icon/svgs/CallColor.svg?react";
import BuildingColor from "../../assets/icon/svgs/BuildingColor.svg?react";
import TelegramIcon from "../../assets/icon/svgs/Telegram.svg?react";
import WhatsAppIcon from "../../assets/icon/svgs/Whatsapp.svg?react";
import Mail from "../../assets/icon/svgs/Mail.svg?react";
import Call from "../../assets/icon/svgs/Call.svg?react";
import Trash from "../../assets/icon/svgs/TrashBind.svg?react";
import EparaksIcon from "../../assets/icon/svgs/EparaksIcon.svg?react";
import SmartIdIcon from "../../assets/icon/svgs/SmartIdIcon.svg?react";
import UserIcon from "../../assets/icon/svgs/UserIcon.svg?react";
import Certificate from "../../assets/icon/svgs/Certificate.svg?react";
import ArrowSimple from "../../assets/icon/svgs/ArrowSimple.svg?react";
import CalendarSimple from "../../assets/icon/svgs/CalendarSimple.svg?react";
import { sensorTypeIconMapColors } from "@/utils/sensorTypesHelper";
import Chip, { ChipStatusEnum } from "../customComponents/Chip";
import BillsService, {
  ApartmentInvoices,
  EmergencyInfo,
  houseAdminDetailsSchema,
  IMetersPage,
  INotices,
  ResultMeters,
} from "@/api-client/api/services/billsService/billsService";
import { InputDialog } from "../customComponents/InputDialog";
import Upload from "../../assets/icon/svgs/Upload.svg?react";
import { useState, useEffect } from "react";
import { SelectWithPlaceHolder } from "../customComponents/SelectWithPlaceHolder";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm } from "react-hook-form";
import Plus from "../../assets/icon/svgs/Plus.svg?react";
import { PopUpCreateNews } from "../pop-ups/PopUpCreateNews";
import { ApartmentInfoResult } from "@/api-client/api/services/houseManager/houseManager";
import { TextareaFormField } from "../customComponents/TextareaFromField";
import { useNavigate } from "react-router-dom";
import i18next from "i18next";

export interface InvoiceEntity {
  invoice_id?: string | undefined;
  apartment_id?: string | undefined;
  invoice_name?: string | undefined;
  total_amount?: number | undefined;
  due_date?: string | undefined;
  status?: string | undefined;
  pdf_url?: string | undefined;
}

export const HouseManagerBills = ({
  data,
  selectedPeriod,
  isEditingCurrentPeriod,
  isEditingClosedPeriod,
  changedEntities,
  setChangedEntities,
  localPdfFiles,
  setLocalPdfFiles,
  payBeforeDateForCurrentPeriod,
}: {
  data: ApartmentInvoices[] | undefined;
  selectedPeriod: string;
  isEditingCurrentPeriod: boolean;
  isEditingClosedPeriod: boolean;
  changedEntities: InvoiceEntity[];
  setChangedEntities: (entities: InvoiceEntity[]) => void;
  localPdfFiles: Record<string, File>;
  setLocalPdfFiles: (files: Record<string, File>) => void;
  payBeforeDateForCurrentPeriod: string | undefined;
}) => {
  const { t, i18n } = useTranslation();
  const [draggedInvoiceId, setDraggedInvoiceId] = useState<string | null>(null);
  const [inputValues, setInputValues] = useState<Record<string, string>>({});
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | null>
  >({});

  useEffect(() => {
    setInputValues(() => {
      const result: Record<string, string> = {};

      data?.forEach((user) => {
        user.invoices.forEach((invoice) => {
          result[invoice.invoice_id] = invoice.total_amount?.toString() ?? "";
        });
      });

      return result;
    });
  }, [data]);

  const handleChangedEntity = (
    invoiceId: string,
    field: "total_amount" | "invoice_name" | "due_date" | "status" | "pdf_url",
    value: string | number | File
  ) => {
    const existing = changedEntities.find(
      (i: InvoiceEntity) => i.invoice_id === invoiceId
    );
    if (existing) {
      setChangedEntities(
        changedEntities.map((i: InvoiceEntity) =>
          i.invoice_id === invoiceId ? { ...i, [field]: value } : i
        )
      );
    } else {
      setChangedEntities([
        ...changedEntities,
        { invoice_id: invoiceId, [field]: value },
      ]);
    }
  };

  const handleInputChange = (invoiceId: string, value: string) => {
    setInputValues((prev) => ({
      ...prev,
      [invoiceId]: value,
    }));
    handleChangedEntity(invoiceId, "total_amount", Number(value));
  };

  const handleValidationError = (invoiceId: string, error: string | null) => {
    setValidationErrors((prev) => ({
      ...prev,
      [invoiceId]: error,
    }));
  };

  const handleDragEnter = (invoiceId: string) => {
    if (isEditingCurrentPeriod) {
      setDraggedInvoiceId(invoiceId);
    }
  };

  const handleFileDrop = (
    e: React.DragEvent<HTMLDivElement>,
    invoiceId: string
  ) => {
    e.preventDefault();
    if (!isEditingCurrentPeriod) return;

    setDraggedInvoiceId(null);

    const file = e.dataTransfer.files[0];
    if (!file || file.type !== "application/pdf") {
      alert("Please drag and drop a PDF file.");
      return;
    }
    console.log("file", file);

    setLocalPdfFiles({
      ...localPdfFiles,
      [invoiceId]: file,
    });

    handleChangedEntity(invoiceId, "pdf_url", file);
  };

  return (
    <div>
      <div className="flex justify-between text-[12px] font-medium">
        <span className="w-[12.81%] text-[#00000080]">{t("total_amount")}</span>
        <span className="w-[12.81%] text-[#00000080]">
          {t("house_manager.invoices")}
        </span>
        <span className="w-[12.81%] text-[#00000080]">
          {t("house_manager.address")}
        </span>
        <span className="w-[3.07%] text-[#00000080]">Ap.</span>
        <span className="w-[7.67%] text-[#00000080]">{t("period")}</span>
        <div className="w-[12.73%] text-[#00000080] flex justify-between">
          <span className="flex">{t("pay_before")}</span>

          {selectedPeriod == "closed_periods" && (
            <span className="flex w-[38%]">{t("house_manager.status")}</span>
          )}
        </div>
        <div className="w-[11.96%] text-[#00000080]">
          {t("paymentDialog.details")}
        </div>
        {/* <div className="w-[13.19%] max-w-[160px] text-[#00000080] pl-[10px]">
          {t("house_manager.actions")}
        </div> */}
      </div>
      {data?.map((item) => (
        <div key={item.apartment_id} className="flex border-b flex-col">
          {item.invoices.map((item, index) => (
            <div
              className={`flex justify-between items-center py-2 font-medium transition-colors duration-200 ${
                draggedInvoiceId === item.invoice_id
                  ? "bg-[#0027CB0D] border-dashed border-t border-[#0027CB33]"
                  : ""
              }`}
              key={index}
              onDragOver={(e) => isEditingCurrentPeriod && e.preventDefault()}
              onDragEnter={() => handleDragEnter(item.invoice_id)}
              onDrop={(e) => handleFileDrop(e, item.invoice_id)}
            >
              <span className="w-[12.81%] text-lg flex items-center row gap-1">
                {isEditingCurrentPeriod ? (
                  <InputDialog
                    id={`HouseManagerBillsAmount.${item.invoice_id}`}
                    inputSize="sm"
                    inputValue={
                      changedEntities
                        .find((i) => i.invoice_id === item.invoice_id)
                        ?.total_amount?.toString() ??
                      inputValues[item.invoice_id] ??
                      null
                    }
                    validationType="numbers"
                    placeholder={
                      item.total_amount
                        ? item.total_amount.toString()
                        : t("total_amount")
                    }
                    disablePlaceholderAnimation={true}
                    setInputValue={(value) =>
                      handleInputChange(item.invoice_id, value)
                    }
                    validationError={validationErrors[item.invoice_id]}
                    setValidationError={(error) =>
                      handleValidationError(item.invoice_id, error)
                    }
                  />
                ) : (
                  <>
                    {item.total_amount ? (
                      <>
                        {item.total_amount}{" "}
                        <span className="text-[12px] mb-[5px]">€</span>
                      </>
                    ) : (
                      <span className="text-[#00000080] text-[12px]">
                        {t("no_data")}
                      </span>
                    )}
                  </>
                )}
              </span>
              <span className={"w-[12.81%] text-[12px] flex items-center"}>
                {isEditingCurrentPeriod ? (
                  <InputDialog
                    id={`HouseManagerBillsName.${item.invoice_id}`}
                    inputSize="sm"
                    inputValue={
                      changedEntities.find(
                        (i) => i.invoice_id === item.invoice_id
                      )?.invoice_name ??
                      item.invoice_name ??
                      null
                    }
                    placeholder={
                      item.invoice_name ? item.invoice_name : t("invoice")
                    }
                    disablePlaceholderAnimation={true}
                    setInputValue={(value) => {
                      handleChangedEntity(
                        item.invoice_id,
                        "invoice_name",
                        value
                      );
                    }}
                    validationError={null}
                    setValidationError={(value) => {
                      console.log(value);
                    }}
                  />
                ) : (
                  <span
                    className={
                      item.invoice_name ? "" : "text-[#00000080] text-[12px]"
                    }
                  >
                    {item.invoice_name ? item.invoice_name : t("no_data")}
                  </span>
                )}
              </span>
              <span className="w-[12.81%] text-[12px] flex items-center truncate">
                {item.building_address}
              </span>
              <span className="w-[3.07%] text-[12px] flex items-center ">
                {item.apartment_number}
              </span>
              <span className="w-[7.67%] text-[12px] flex items-center">
                {getMonthYearFormat(
                  item.billing_month || "2025-01",
                  i18n.language
                )}
              </span>
              <div className="w-[12.73%] flex items-center justify-between">
                <div
                  className={
                    item.status === "debt"
                      ? "text-[#FF0000] text-[12px] flex-1"
                      : "text-[12px] flex-1"
                  }
                >
                  {!isEditingCurrentPeriod ? (
                    <>
                      {getMonthWithDayFormatDate(
                        item.due_date || "2025-01",
                        i18n.language
                      )}
                    </>
                  ) : (
                    <>
                      {getMonthWithDayFormatDate(
                        payBeforeDateForCurrentPeriod || item.due_date,
                        i18n.language
                      )}
                    </>
                  )}
                </div>
                {selectedPeriod == "closed_periods" && (
                  <>
                    {isEditingClosedPeriod ? (
                      <SelectWithPlaceHolder
                        selectValue={`${
                          changedEntities.find(
                            (i) => i.invoice_id === item.invoice_id
                          )?.status || item.status
                        }`}
                        onSelectChange={(val) => {
                          console.log(val);
                          handleChangedEntity(item.invoice_id, "status", val);
                        }}
                        selectValues={[
                          { name: t("apartment.debt"), value: "debt" },
                          { name: t("apartment.unpaid"), value: "unpaid" },
                          { name: t("apartment.paid"), value: "paid" },
                        ]}
                        size="sm"
                        manyChoices={false}
                      />
                    ) : (
                      <div className="min-w-[38%]">
                        {(() => {
                          let textColor = "";
                          let bgColor = "";

                          switch (item.status) {
                            case "debt":
                              textColor = "#FF0000";
                              bgColor = "#FF00001A";
                              break;
                            case "paid":
                              textColor = "#000000";
                              bgColor = "#0000001A";
                              break;
                            default:
                              textColor = "#0027CB";
                              bgColor = "#0027CB1A";
                          }

                          return (
                            <span
                              className="text-[12px] px-2 py-[1px] rounded-[24px]"
                              style={{
                                color: textColor,
                                backgroundColor: bgColor,
                              }}
                            >
                              {t(`apartment.${item.status}`)}
                            </span>
                          );
                        })()}
                      </div>
                    )}
                  </>
                )}
              </div>
              {isEditingCurrentPeriod ? (
                <div className="w-[11.96%] flex flex-row gap-1 items-center">
                  {(localPdfFiles[item.invoice_id] || item.pdf_url) && (
                    <a
                      href={
                        localPdfFiles[item.invoice_id]
                          ? URL.createObjectURL(localPdfFiles[item.invoice_id])
                          : item.pdf_url!
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-[30px] text-[#0027CB]"
                    >
                      <FileBlue width={24} height={30} />
                    </a>
                  )}
                  <div
                    className={`flex gap-1 bg-[#0027CB0D] border-[#0027CB33] text-[12px] rounded-[10px] py-1 px-2 items-center text-[#0029cb84]  border-2 border-dashed${
                      draggedInvoiceId === item.invoice_id
                        ? "bg-[#00000000] text-[#001D98] border-none"
                        : ""
                    }`}
                  >
                    <div className="w-[16px] h-[16px]">
                      <Upload width={16} height={16} />
                    </div>
                    <span className="leading-[120%]">
                      {localPdfFiles[item.invoice_id] || item.pdf_url
                        ? t("house_manager.drag_and_drop_pdf_to_replace")
                        : t("house_manager.drag_and_drop_pdf")}{" "}
                      {localPdfFiles[item.invoice_id]
                        ? localPdfFiles[item.invoice_id].name
                        : item.pdf_url?.split("/").pop() ?? ""}
                    </span>
                  </div>
                </div>
              ) : (
                <>
                  {!item.pdf_url ? (
                    <div className="flex w-[11.96%] gap-1 text-[12px] items-center text-[grey]">
                      {t("paymentDialog.no_pdf_available")}
                    </div>
                  ) : (
                    <a
                      href={item.pdf_url}
                      className="w-[11.96%] text-[17px] flex gap-[8px] text-[#0027CB]"
                    >
                      <div className="w-[16px] h-[16px]">
                        <FileBlue width={24} height={24} />
                      </div>
                      {item.pdf_url && (
                        <span className="inline-block truncate">
                          {item.pdf_url?.split("/").pop()}
                        </span>
                      )}
                    </a>
                  )}
                </>
              )}

              {/* <div className="w-[160px] flex items-center justify-between">
                <div className="flex flex-row">
                  <div className="p-2 text-[#00000080] hover:text-blue-medium cursor-pointer">
                    <HomeInfo className="w-[24px] h-[24px]" />
                  </div>
                  <div className="p-2 text-[#00000080] hover:text-blue-medium cursor-pointer">
                    <ChatDots className="w-[24px] h-[24px]" />
                  </div>
                  <div className="p-2 text-[#00000080] hover:text-blue-medium cursor-pointer">
                    <SendNotification className="w-[24px] h-[24px]" />
                  </div>
                </div>
                <div className="p-2 text-[#00000080] hover:text-blue-medium cursor-pointer">
                  <Edit className="w-[24px] h-[24px]" />
                </div>
              </div> */}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export const HouseManagerMeters = ({
  data,
}: {
  data: IMetersPage | undefined;
}) => {
  const { t } = useTranslation();

  const MetersInfoAccordeon = ({ item }: { item: ResultMeters }) => {
    const [expanded, setExpanded] = useState(false);

    const owners = item.meters.filter(
      (meter) =>
        meter.total_reading_by_user === null &&
        meter.current_month_total_reading === null
    );

    return (
      <div
        className="flex flex-col gap-2"
        onClick={() => setExpanded(!expanded)}
      >
        <div
          className={`flex flex-col pl-4 py-3 gap-3 border-1 rounded-[16px] border-[1px] border-[#0000001A] ${
            expanded ? "bg-[#F5F5F5]" : "bg-[white]"
          }`}
        >
          <div className="flex flex-row justify-between text-[16px] font-medium">
            <span className="w-[15.11%]">{item.address}</span>
            <span className="w-[3.02%]">{item.apartment_number}</span>
            <span className="w-[9.06%]">
              {new Date(item.period).toLocaleDateString(i18next.language, {
                month: "long",
                year: "numeric",
              })}
            </span>
            <span className="w-[15.11%]"></span>
            <span className="w-[15.11%]"></span>
            <span className="w-[15.11%]">
              {owners.length ? (
                <Chip
                  text={t("house_manager.not_received")}
                  status={ChipStatusEnum.RED}
                />
              ) : null}
            </span>
            {/* <div className="flex w-[200px] text-[#00000080] items-center gap-4">
              <TotalBill width={24} height={24} className="cursor-pointer" />
              <SendNotification
                width={24}
                height={24}
                className="cursor-pointer"
              />
              <HomeInfo width={24} height={24} className="cursor-pointer" />
              <ChatDots width={24} height={24} className="cursor-pointer" />
              <div className="pl-1 py-1 cursor-pointer">
                <ArrowSimple
                  width={18}
                  height={18}
                  className={`${expanded ? "" : "rotate-180"}`}
                />
              </div>
            </div> */}
          </div>

          {expanded && (
            <>
              <span className=" border-[0.5px] border-[#0000001A]" />
              <div className="flex flex-col gap-4">
                {item.meters.map((meter) => {
                  const icon =
                    sensorTypeIconMapColors[
                      meter.sensor_type as keyof typeof sensorTypeIconMapColors
                    ];
                  let updatedCurrent = meter.current_month_total_reading;
                  if (
                    meter.total_reading_by_user &&
                    meter.total_reading_by_user >
                      Number(meter.current_month_total_reading)
                  ) {
                    updatedCurrent = meter.total_reading_by_user.toString();
                  }
                  return (
                    <>
                      <div className="flex flex-row justify-between text-[16px] font-medium">
                        <span className="w-[15.11%] flex flex-row gap-2">
                          <img
                            src={icon}
                            alt={icon}
                            className="w-[24px] h-[24px]"
                          />
                          {t(`meters.${meter.sensor_type}`)}
                        </span>
                        <span className="w-[3.02%] flex flex-row gap-2"></span>
                        <span className="w-[9.06%] flex flex-col gap-2"></span>
                        <span className="w-[15.11%]">
                          {meter.sensor_number ?? "--"}
                        </span>
                        <span className="w-[15.11%]">
                          {meter.previous_month_total_reading ?? "--"}
                        </span>
                        <span className="w-[15.11%]">
                          {updatedCurrent ?? (
                            <Chip
                              text={t("house_manager.not_received")}
                              status={ChipStatusEnum.RED}
                            />
                          )}
                        </span>
                        {/* <div className="flex w-[200px] items-center justify-center"></div> */}
                      </div>
                    </>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between text-[12px] font-medium pl-4">
        <span className="min-w-[15.11%] text-[#00000080]">
          {t("house_manager.address")}
        </span>
        <span className="min-w-[3.02%] text-[#00000080]">{t("Ap.")}</span>
        <span className="min-w-[9.06%] text-[#00000080]">
          {t("house_manager.for_the_period")}
        </span>
        <span className="min-w-[15.11%] text-[#00000080]">
          {t("meters.sensor_number")}
        </span>
        <span className="min-w-[15.11%] text-[#00000080]">
          {t("house_manager.previous")}
        </span>
        <span className="min-w-[15.11%] text-[#00000080]">
          {t("house_manager.current")}
        </span>
        {/* <div className="w-[200px] text-[#00000080]">
          {t("house_manager.actions")}
        </div> */}
      </div>
      {data?.result.map((item, index) => (
        <MetersInfoAccordeon key={index} item={item} />
      ))}
    </div>
  );
};

export const HouseManagerHousesInfo = ({
  data,
  isEditingHouseInfo,
  selectedBuildAddress,
  onSaveRef,
  loadHouseInfo,
  getEmergencyInfo,
}: {
  data: EmergencyInfo | undefined;
  isEditingHouseInfo: boolean;
  selectedBuildAddress: { label: string; value: string } | undefined;
  onSaveRef: React.MutableRefObject<() => void>;
  loadHouseInfo: boolean;
  getEmergencyInfo: () => void;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [emailError, setEmailError] = useState<string | null>(null);
  const [editingAccessCode, setEditingAccessCode] = useState<
    { id: string; value: string }[] | undefined
  >([]);

  const methods = useForm({
    resolver: zodResolver(houseAdminDetailsSchema),
    defaultValues: {
      house_admin_details: {
        first_name: data?.house_admin_details?.first_name ?? "",
        last_name: data?.house_admin_details?.last_name ?? "",
        phone_number: data?.house_admin_details?.phone_number ?? "",
        email: data?.house_admin_details?.email ?? "",
      },
      info: data?.info ?? "",
      contacts_info: data?.contacts_info ?? "",
      telegram_link: data?.telegram_link ?? "",
      whatsapp_link: data?.whatsapp_link ?? "",
      service_company_debt: data?.service_company_debt ?? "",
      utility_debt: data?.utility_debt ?? "",
      cumulative_fund: data?.cumulative_fund ?? "",
    },
  });

  const {
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = methods;

  const handleEditingAccessCode = (id: string, value: string) => {
    setEditingAccessCode(
      editingAccessCode?.map((item) =>
        item.id === id ? { ...item, value } : item
      )
    );
  };

  const handleAddNewAccessCode = () => {
    setEditingAccessCode([
      ...(editingAccessCode ?? []),
      { id: `${Date.now()}`, value: "" },
    ]);
  };

  const handleDeleteAccessCode = (id: string) => {
    setEditingAccessCode(editingAccessCode?.filter((item) => item.id !== id));
  };

  const sendNewHouseInfo = async () => {
    const email = getValues().house_admin_details.email;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email) && email !== "") {
      setEmailError(t("popUpAddRenter.invalid_email"));
      return;
    }

    setEmailError(null);

    try {
      const payload = {
        ...getValues(),
        access_codes: editingAccessCode?.map((item) => item.value) ?? [],
      };

      const response = await BillsService.putEmergencyInfo(
        Number(selectedBuildAddress?.value),
        payload
      );

      getEmergencyInfo();
      return [response];
    } catch (error) {
      console.error("Error while sending house info:", error);
    }
  };

  useEffect(() => {
    if (onSaveRef) {
      onSaveRef.current = sendNewHouseInfo;
    }
  }, [editingAccessCode, selectedBuildAddress]);

  useEffect(() => {
    const formattedCodes = data?.access_codes?.map((item, index) => ({
      id: `${index}-${Date.now()}`,
      value: item,
    }));
    setEditingAccessCode(formattedCodes);
  }, [data?.access_codes]);

  return (
    <div className="flex flex-row gap-2 justify-between">
      <FormProvider {...methods}>
        {!loadHouseInfo ? (
          <>
            <div className="flex-1 flex flex-col gap-4 p-4 border-2 border-[#0000001A] rounded-[16px]">
              <div className="flex flex-row gap-2 items-center">
                <BuildingColor className="w-[32px] h-[32px]" />
                <span className="text-[20px] font-medium">
                  {t("house_manager.building_information")}
                </span>
              </div>
              <div className="flex flex-col gap-2">
                <p className="text-[12px] text-[#00000080] font-medium">
                  {t("house_manager.information_for_residents")}
                </p>
                <div className="flex flex-1 flex-col gap-3 font-medium">
                  {isEditingHouseInfo ? (
                    <TextareaFormField
                      control={methods.control}
                      name="info"
                      placeholder={t("house_manager.information_for_residents")}
                    />
                  ) : (
                    <p className="text-[18px] whitespace-pre-line" key={12}>
                      {data?.info ? data?.info : t("no_data")}
                    </p>
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-2">
                <p className="text-[12px] text-[#00000080] font-medium">
                  {t("house_manager.access_codes")}
                </p>
                {isEditingHouseInfo && (
                  <button
                    key="add_access_code"
                    onClick={() => handleAddNewAccessCode()}
                    className="flex w-fit text-[#0027CB] font-medium flex-row gap-1 items-center"
                  >
                    <Plus width={24} height={24} />
                    {t("house_manager.add_field")}
                  </button>
                )}
                <div className="flex flex-1 flex-col gap-2">
                  {editingAccessCode?.map((item, index) => (
                    <>
                      {isEditingHouseInfo ? (
                        <div key={index} className="flex flex-row gap-2">
                          <div className="w-[100%]">
                            <InputDialog
                              id={`HouseManagerAccessCode.${item.id}`}
                              inputSize="sm"
                              inputValue={item.value}
                              placeholder={t("house_manager.access_codes")}
                              setInputValue={(value) => {
                                handleEditingAccessCode(item.id, value);
                              }}
                              validationError={null}
                              setValidationError={() => {}}
                            />
                          </div>
                          <button
                            key="delete_access_code"
                            onClick={() => handleDeleteAccessCode(item.id)}
                            className="text-[#0027CB] font-medium flex-row gap-1 items-center"
                          >
                            <Trash width={24} height={24} />
                          </button>
                        </div>
                      ) : (
                        <>
                          <p className="text-[18px] font-medium" key={index}>
                            {item.value}
                          </p>
                          {index !== editingAccessCode?.length - 1 && (
                            <div className="border-[0.5px] border-[#0000001A] w-full h-[1px]" />
                          )}
                        </>
                      )}
                    </>
                  ))}
                </div>
              </div>
              <div className="flex flex-col gap-2">
                <p className="text-[12px] text-[#00000080] font-medium">
                  {t("house_manager.funds_and_debts")}
                </p>
                <div className="flex flex-1 flex-col gap-3 font-medium">
                  {isEditingHouseInfo ? (
                    <>
                      <InputDialog
                        inputSize="sm"
                        id={`HouseManagerFundsAndDebts.service_company_debt`}
                        disablePlaceholderAnimation={false}
                        inputValue={watch("service_company_debt") ?? null}
                        placeholder={t("house_manager.service_company_debt")}
                        setInputValue={(value) => {
                          setValue("service_company_debt", value);
                        }}
                        validationType={"numbers"}
                        validationError={null}
                        setValidationError={() => {}}
                      />
                      <InputDialog
                        inputSize="sm"
                        id={`HouseManagerFundsAndDebts.utility_debt`}
                        disablePlaceholderAnimation={false}
                        inputValue={watch("utility_debt") ?? null}
                        placeholder={t("house_manager.utility_debt")}
                        setInputValue={(value) => {
                          setValue("utility_debt", value);
                        }}
                        validationType={"numbers"}
                        validationError={null}
                        setValidationError={() => {}}
                      />
                      <InputDialog
                        inputSize="sm"
                        id={`HouseManagerFundsAndDebts.cumulative_fund`}
                        disablePlaceholderAnimation={false}
                        inputValue={watch("cumulative_fund") ?? null}
                        placeholder={t("house_manager.cumulative_fund")}
                        setInputValue={(value) => {
                          setValue("cumulative_fund", value);
                        }}
                        validationType={"numbers"}
                        validationError={null}
                        setValidationError={() => {}}
                      />
                    </>
                  ) : (
                    <>
                      <div className="flex flex-row justify-between">
                        <p className="text-[18px]" key={12}>
                          {data?.service_company_debt ? (
                            <>
                              {data?.service_company_debt}
                              <span className="text-[12px] align-super">
                                {" "}
                                €
                              </span>
                            </>
                          ) : (
                            t("no_data")
                          )}
                        </p>
                        <span className="text-[15px] text-[#00000080]">
                          {t("house_manager.service_company_debt")}
                        </span>
                      </div>
                      <div className="border-[0.5px] border-[#0000001A] w-full h-[1px]" />

                      <div className="flex flex-row justify-between">
                        <p className="text-[18px]" key={12}>
                          {data?.utility_debt ? (
                            <>
                              {data?.utility_debt}
                              <span className="text-[12px] align-super">
                                {" "}
                                €
                              </span>
                            </>
                          ) : (
                            t("no_data")
                          )}
                        </p>
                        <span className="text-[15px] text-[#00000080]">
                          {t("house_manager.utility_debt")}
                        </span>
                      </div>
                      <div className="border-[0.5px] border-[#0000001A] w-full h-[1px]" />

                      <div className="flex flex-row justify-between">
                        <p className="text-[18px]" key={12}>
                          {data?.cumulative_fund ? (
                            <>
                              {data?.cumulative_fund}
                              <span className="text-[12px] align-super">
                                {" "}
                                €
                              </span>
                            </>
                          ) : (
                            t("no_data")
                          )}
                        </p>
                        <span className="text-[15px] text-[#00000080]">
                          {t("house_manager.cumulative_fund")}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div
                key="projects_and_repair_works"
                onClick={() => {
                  navigate(
                    `/projects-and-repair-works?building_id=${selectedBuildAddress?.value}&apartment_name=${selectedBuildAddress?.label}`
                  );
                }}
                className="flex flex-row justify-between rounded-[12px] bg-[#F5F5F5] px-4 py-3 cursor-pointer hover:bg-[#0027CB0D]"
              >
                <div className="flex flex-row gap-2">
                  <CalendarSimple width={24} height={24} />
                  {t("house_manager.projects_and_repair_works")}
                </div>
                <div className="py-1">
                  <ArrowSimple width={17} height={17} className="rotate-90" />
                </div>
              </div>
            </div>
            <div className="flex-1 flex flex-col p-4 gap-4 border-2 border-[#0000001A] rounded-[16px]">
              <div className="flex flex-row gap-2 items-center">
                <CallColor width={32} height={32} />
                <span className="text-[20px] font-medium">
                  {t("house_manager.contacts_of_service")}
                </span>
              </div>
              <div className="flex flex-col gap-2">
                {isEditingHouseInfo && (
                  <span className="text-[12px] text-[#00000080] font-medium">
                    {t("house_manager.house_manager")}
                  </span>
                )}
                <div className="flex flex-row gap-4">
                  <div className="flex-1 flex flex-row gap-2">
                    {isEditingHouseInfo ? (
                      <div className="flex flex-col gap-4 flex-1">
                        <InputDialog
                          inputSize="sm"
                          id={`HouseManagerHouseManager.first_name`}
                          disablePlaceholderAnimation={false}
                          inputValue={
                            watch("house_admin_details.first_name") ?? null
                          }
                          placeholder={t("house_manager.first_name")}
                          setInputValue={(value) => {
                            setValue("house_admin_details.first_name", value);
                          }}
                          validationError={
                            errors.house_admin_details?.first_name?.message ??
                            null
                          }
                          setValidationError={() => {}}
                        />
                        <InputDialog
                          inputSize="sm"
                          id={`HouseManagerHouseManager.last_name`}
                          disablePlaceholderAnimation={false}
                          inputValue={
                            watch("house_admin_details.last_name") ?? null
                          }
                          placeholder={t("house_manager.last_name")}
                          setInputValue={(value) => {
                            setValue("house_admin_details.last_name", value);
                          }}
                          validationError={
                            errors.house_admin_details?.last_name?.message ??
                            null
                          }
                          setValidationError={() => {}}
                        />
                      </div>
                    ) : (
                      <span
                        className={`text-[18px] font-medium pt-[10px] leading-[40%] ${
                          isEditingHouseInfo ? "" : "text-[#00000080]"
                        }`}
                      >
                        {data?.house_admin_details?.first_name &&
                        data?.house_admin_details?.last_name
                          ? `${data?.house_admin_details?.first_name} ${data?.house_admin_details?.last_name}`
                          : t("no_data")}
                      </span>
                    )}
                  </div>
                  <div className="flex-1 flex flex-col gap-2">
                    {isEditingHouseInfo ? (
                      <div className="flex flex-col gap-4 flex-1">
                        <InputDialog
                          inputSize="sm"
                          id={`HouseManagerHouseManager.phone_number`}
                          disablePlaceholderAnimation={false}
                          inputValue={
                            watch("house_admin_details.phone_number") ?? null
                          }
                          placeholder={t("house_manager.phone_number")}
                          setInputValue={(value) => {
                            const filtered = value.replace(/[^\d+\s]/g, "");
                            setValue(
                              "house_admin_details.phone_number",
                              filtered
                            );
                          }}
                          validationError={
                            errors.house_admin_details?.phone_number?.message ??
                            null
                          }
                          setValidationError={() => {}}
                        />
                        <InputDialog
                          inputSize="sm"
                          id={`HouseManagerHouseManager.email`}
                          disablePlaceholderAnimation={false}
                          inputValue={
                            watch("house_admin_details.email") ?? null
                          }
                          placeholder={t("house_manager.email")}
                          setInputValue={(value) => {
                            setValue("house_admin_details.email", value);
                          }}
                          validationError={
                            errors.house_admin_details?.email?.message ??
                            emailError ??
                            null
                          }
                          setValidationError={() => {}}
                        />
                      </div>
                    ) : (
                      <>
                        <div className="flex flex-row items-center justify-between">
                          <div
                            className={`flex flex-row gap-1 items-center ${
                              data?.house_admin_details?.phone_number
                                ? "text-[#0027CB]"
                                : "text-[#00000080]"
                            }`}
                          >
                            <Call width={16} />
                            <span className="text-[12px] font-medium ">
                              {data?.house_admin_details?.phone_number
                                ? data?.house_admin_details?.phone_number
                                : t("no_data")}
                            </span>
                          </div>
                          <span className="text-[15px] text-[#00000080]">
                            House manager
                          </span>
                        </div>
                        <div
                          className={`flex flex-row gap-1 items-center ${
                            data?.house_admin_details?.email
                              ? "text-[#0027CB]"
                              : "text-[#00000080]"
                          }`}
                        >
                          <Mail width={16} />
                          <span className="text-[12px] font-medium">
                            {data?.house_admin_details?.email
                              ? data?.house_admin_details?.email
                              : t("no_data")}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {isEditingHouseInfo &&
                  !data?.house_admin_details?.phone_number &&
                  !data?.house_admin_details?.email &&
                  !data?.house_admin_details?.first_name &&
                  !data?.house_admin_details?.last_name && (
                    <span className="text-[15px] font-medium text-[#FF0000]">
                      {t("house_manager.fill_in_your_information")}
                    </span>
                  )}
                <div className="flex flex-col gap-2">
                  <p className="text-[12px] text-[#00000080] font-medium">
                    {t("house_manager.emergency_services")}
                  </p>
                  <div className="flex flex-1 flex-col gap-3 font-medium">
                    {isEditingHouseInfo ? (
                      <TextareaFormField
                        control={methods.control}
                        name="contacts_info"
                        placeholder={t("house_manager.emergency_services")}
                      />
                    ) : (
                      <p className="text-[18px] whitespace-pre-line" key={12}>
                        {data?.contacts_info
                          ? data?.contacts_info
                          : t("no_data")}
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-[13px]">
                  <p className="text-[12px] text-[#00000080] font-medium">
                    {t("house_manager.house_chats")}
                  </p>
                  {isEditingHouseInfo ? (
                    <>
                      <InputDialog
                        inputSize="sm"
                        id={`HouseManagerHouseChats.telegram_link`}
                        disablePlaceholderAnimation={false}
                        inputValue={watch("telegram_link") ?? null}
                        placeholder={t("house_manager.telegram_link")}
                        setInputValue={(value) => {
                          setValue("telegram_link", value);
                        }}
                        validationError={null}
                        setValidationError={() => {}}
                      />
                      <InputDialog
                        inputSize="sm"
                        id={`HouseManagerHouseChats.whatsapp_link`}
                        disablePlaceholderAnimation={false}
                        inputValue={watch("whatsapp_link") ?? null}
                        placeholder={t("house_manager.whatsapp_link")}
                        setInputValue={(value) => {
                          setValue("whatsapp_link", value);
                        }}
                        validationError={null}
                        setValidationError={() => {}}
                      />
                    </>
                  ) : (
                    <>
                      <div className="flex flex-row gap-4 text-[18px] font-medium items-center">
                        <div className="flex-1">Telegram</div>
                        <div className="flex-1 flex flex-row gap-1 items-center">
                          <TelegramIcon width={16} height={16} />
                          <p className="text-[12px] text-[#0027CB]">
                            {data?.telegram_link
                              ? data?.telegram_link
                              : t("no_data")}
                          </p>{" "}
                        </div>
                      </div>
                      <div className="border-[0.5px] border-[#0000001A] w-full h-[1px]" />
                      <div className="flex flex-row gap-4 text-[18px] font-medium items-center">
                        <div className="flex-1">WhatsApp</div>
                        <div className="flex-1 flex flex-row gap-1 items-center">
                          <WhatsAppIcon width={16} height={16} />
                          <p className="text-[12px] text-[#0027CB] ">
                            {data?.whatsapp_link
                              ? data?.whatsapp_link
                              : t("no_data")}
                          </p>{" "}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          <div>Load</div>
        )}
      </FormProvider>
    </div>
  );
};

export const HouseManagerApartamentInfo = ({
  data,
}: {
  data: ApartmentInfoResult[] | undefined;
}) => {
  const { t } = useTranslation();

  const HouseInfoAccordeon = ({ item }: { item: ApartmentInfoResult }) => {
    const [expanded, setExpanded] = useState(false);
    const owners = item.users.filter((user) => user.user_type === "owner");

    return (
      <div
        className="flex flex-col gap-2"
        onClick={() => setExpanded(!expanded)}
      >
        <div
          className={`flex flex-col px-4 py-3 gap-3 border-1 rounded-[16px] border-[1px] border-[#0000001A] ${
            expanded ? "bg-[#F5F5F5]" : "bg-[white]"
          }`}
        >
          <div className="flex flex-row justify-between text-[16px] font-medium">
            <span className="w-[23%]">{item.address}</span>
            <span className="w-[23%]">{item.apartment_number}</span>
            <span className="w-[23%]"></span>
            <span className="w-[23%]"></span>
            <span className="w-[6%]"></span>
            <div className="flex items-center justify-center">
              <ArrowSimple
                width={15}
                height={15}
                className={`${expanded ? "" : "rotate-180"}`}
              />
            </div>
          </div>

          {expanded && (
            <>
              <span className=" border-[0.5px] border-[#0000001A]" />

              {item.users.map((user, index) => (
                <>
                  <div className="flex flex-row justify-between text-[16px] font-medium">
                    <span className="w-[23%] flex flex-row gap-2">
                      {user.smartId && (
                        <>
                          <SmartIdIcon width={24} height={24} /> {user.smartId}{" "}
                        </>
                      )}
                      {user.eparaksId && (
                        <>
                          <EparaksIcon width={24} height={24} />{" "}
                          {user.eparaksId}{" "}
                        </>
                      )}
                      {user.email && (
                        <span className="flex flex-row gap-1 items-center text-[#0027CB]">
                          <Mail width={24} height={24} /> {user.email}
                        </span>
                      )}
                    </span>
                    <span className="w-[23%] flex flex-row gap-2">
                      {user.user_name && (
                        <>
                          <UserIcon width={24} height={24} /> {user.user_name}
                        </>
                      )}
                      {user.company_name && (
                        <>
                          <Certificate width={24} height={24} />{" "}
                          {user.company_name}
                        </>
                      )}
                    </span>
                    <span className="w-[23%] text-[12px] flex flex-col gap-2">
                      {user.phone && (
                        <div className="flex flex-row gap-1 items-center text-[#0027CB]">
                          <Call />
                          {user.phone}
                        </div>
                      )}

                      {user.email && (
                        <div className="flex flex-row gap-1 items-center text-[#0027CB]">
                          <Mail />
                          {user.email}
                        </div>
                      )}
                      {user.telegram && (
                        <div className="flex flex-row gap-1 items-center text-[#0027CB]">
                          <TelegramIcon />
                          {user.telegram}
                        </div>
                      )}
                      {user.whatsapp && (
                        <div className="flex flex-row gap-1 items-center text-[#0027CB]">
                          <WhatsAppIcon />
                          {user.whatsapp}
                        </div>
                      )}
                    </span>
                    <span className="w-[23%] text-[12px]">
                      {user.info ?? "--"}
                    </span>
                    <span className="w-[6%]">
                      {user.user_type === "owner" ? (
                        <Chip
                          text={`${Math.floor(100 / owners.length)}%`}
                          status={ChipStatusEnum.BLUE}
                        />
                      ) : (
                        <Chip text={t("renter")} status={ChipStatusEnum.GREY} />
                      )}
                    </span>
                  </div>
                  {index < item.users.length - 1 && (
                    <span className="border-[0.5px] border-[#0000001A]" />
                  )}
                </>
              ))}
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between text-[12px] font-medium px-4">
        <span className="w-[23%] text-[#00000080] flex flex-col">
          <span>{t("house_manager.address")}</span>
          <span>{t("house_manager.id_reg_number_email")}</span>
        </span>
        <span className="w-[23%] text-[#00000080] flex flex-col">
          <span>{t("house_manager.apartament")}</span>
          <span>{t("house_manager.ownership_form_name")}</span>
        </span>
        <span className="w-[23%] text-[#00000080]">{t("footer.contacts")}</span>
        <span className="w-[23%] text-[#00000080]">
          {t("house_manager.comment")}
        </span>
        <span className="w-[6%] text-[#00000080]">
          {t("house_manager.ownership_shares")}
        </span>
      </div>

      {data &&
        data.map((item, index) => {
          return <HouseInfoAccordeon item={item} key={`${index}-${item.apartment_number}`} />;
        })}
    </div>
  );
};

export const HouseManagerNoticesAndNews = ({
  building_id,
  fetchNotices,
  notices,
}: {
  building_id: string;
  fetchNotices: () => void;
  notices: INotices[];
}) => {
  const NewsCard = ({ item }: { item: INotices }) => {
    const { t } = useTranslation();
    const date = new Date(item.created_at);

    const month = date.toLocaleString("en-US", { month: "short" });
    const day = date.getDate();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    const formatted = `${month} ${day} at ${hours}:${minutes}`;

    return (
      <div
        className={`flex flex-col  min-h-[315px] font-medium bg-[#0027CB0D] rounded-[16px] px-2 py-2 gap-2 ${
          item.is_emergency ? "bg-[#FF00000D]" : "bg-[#0027CB0D]"
        }`}
      >
        <div className="flex items-center gap-1 justify-between">
          <div
            className={`flex gap-[10px] items-start ${
              item.is_emergency ? "text-[#FF0000]" : "text-[#0027CB]"
            }`}
          >
            {item.is_emergency ? (
              <Chip text={t("emergency")} status={ChipStatusEnum.RED} />
            ) : (
              <div className="h-[20px]" />
            )}
          </div>
          <PopUpCreateNews
            item={item}
            building_id={Number(building_id)}
            fetchNotices={fetchNotices}
            trigger={
              <div className="bg-[white] text-[#00000080] rounded-[4px] p-2">
                <Edit width={20} height={20} />
              </div>
            }
          />
        </div>

        <span className="text-[15px] px-2">{item.title}</span>
        <span className="text-[12px] px-2 flex-1">{item.description}</span>
        <span className="text-[12px] px-2 text-[#00000080]">{formatted}</span>
      </div>
    );
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-2">
      {notices.map((item, index) => {
        return <NewsCard item={item} key={index} />;
      })}
    </div>
  );
};
